import search from '../../lib/search';
import {getQuestionDisplayLabel, getQuestionTypeLabel, isQuestionDeleted, QUESTION_TYPES} from '../FormBuilderScreen/shared';

export {getQuestionTypeLabel};

// The questions people can see on a form: setup questions first, then repeated ones. Deleted questions are left out.
export function getFormQuestions(form) {
  const byOrder = (a, b) => a.order - b.order;

  return [
    ...(form.contextQuestions || []).slice().sort(byOrder),
    ...(form.questions || []).slice().sort(byOrder)
  ].filter(question => !isQuestionDeleted(question));
}

// The question types used by any of the forms, so the type filter only offers ones that can match.
export function getUsedQuestionTypes(forms) {
  const used = new Set();
  forms.forEach(form => getFormQuestions(form).forEach(question => used.add(question.type)));

  return QUESTION_TYPES.filter(type => used.has(type.value));
}

// Decides whether a form matches the search text and question type filter. A form matches the text by its name or by
// the name of one of its questions, and matches the type when it has a question of that type. When both are set, a
// form found by name still needs a question of the type, and a form found by a question needs that question to be of
// the type.
// Returns null when the form doesn't match, or the questions that matched, so the list can show why it was found. That
// list is empty when the form only matched by name.
export function matchFormQuestions(form, text, type) {
  const query = (text || '').trim();
  const typeFilter = type && type !== 'all' ? type : null;

  const questionsOfType = getFormQuestions(form)
    .filter(question => !typeFilter || question.type === typeFilter);

  if (typeFilter && questionsOfType.length === 0) {
    return null;
  }

  if (!query) {
    return typeFilter ? questionsOfType : [];
  }

  const matchingQuestions = questionsOfType
    .filter(question => search(getQuestionDisplayLabel(question) || '', query));

  if (matchingQuestions.length > 0) {
    return matchingQuestions;
  }

  if (search(form.name || '', query)) {
    return typeFilter ? questionsOfType : [];
  }

  return null;
}
